import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { PrivacyActions } from './privacy.actions';
import { IPrivacyState } from './privacy.state';

export const initialPrivacyState: IPrivacyState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const privacyReducerFn = createReducer(
  initialPrivacyState,
  on(PrivacyActions.reset, (state: IPrivacyState, action) => {
    return new StateBuilder<IPrivacyState>(initialPrivacyState).build();
  }),
  on(PrivacyActions.load, (state: IPrivacyState, action) => {
    return new StateBuilder<IPrivacyState>(state).toLoading().build();
  }),
  on(PrivacyActions.loadSuccess, (state: IPrivacyState, action) => {
    return new StateBuilder<IPrivacyState>(state, action).toLoaded().build();
  }),
  on(PrivacyActions.submit, (state: IPrivacyState, action) => {
    return new StateBuilder<IPrivacyState>(state).toLoading().build();
  }),
  on(PrivacyActions.submitSuccess, (state: IPrivacyState, action) => {
    return new StateBuilder<IPrivacyState>(state, action).toLoaded().build();
  })
);

export function privacyReducer(state: IPrivacyState | undefined, action: Action) {
  return privacyReducerFn(state, action);
}
